import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash';
import { Link } from '@bd/bdcore-named-routes';
import withData from '@bd/bdcore-data';
import { css } from '@bd/bdui-styles/emotion';
import { colors, typography } from '../../styles';

const styles = css`
  background-color: ${colors.color3};
  /* background-image: url('/images/ameritex-icon-blue-36opacity.svg'); */
  background-position: center center;
  background-repeat: no-repeat;
  padding: 45px 0 60px 0;
  text-align: center;
  border-top:6px solid ${colors.color2};
  @media (min-width: 992px) {
    padding: 100px 60px;
  }
  .HomeProcess_title {
    font-family: ${typography.Serif};
    font-weight: 700;
    font-size: 32px;
    color: ${colors.black};
    letter-spacing: 1px;
    text-align: center;
    line-height: 1;
    text-transform: uppercase;
    margin: 0 0 15px 0;
    @media (min-width: 992px) {
      font-size: 48px;
    }
  }
  .HomeProcess_preTitle {
    font-weight: 300;
    display: block;
    @media (min-width: 992px) {
      display: inline ;
      font-weight: 700;
      font-size: 48px;
    }
  }
  .HomeProcess_subTitle {
    font-weight: 700;
    font-size: 24px;
    font-style: italic;
    color: ${colors.black};
    letter-spacing: 1px;
    text-align: center;
    line-height: 1;
    padding: 10px 30px;
    border-top: 1px solid ${colors.color2};
    border-bottom: 1px solid ${colors.color2};
    display: inline-block;
    margin: 0 0 45px 0;
    @media (min-width: 992px) {
      font-weight: 36px;
      padding: 15px 100px;
    }
  }
  .HomeProcess_stepWrapper {
    margin: 0 0 45px 0;
    text-align: center;
    justify-content: center;
    align-items: center;
  }
  .HomeProcess_stepImage {
    background-color: #FFFFFF;
    width: 220px;
    height: 220px;
    border-radius: 50%;
    color: ${colors.black};
    font-size: 18px;
    font-weight: 700;
    text-transform: uppercase;
    line-height: 1;
    padding: 25px 0;
    display: inline-block;
    margin: 0 0 15px 0;
    padding: 60px 0;
    border: 1px solid #ccc;
    img {
      width: auto;
      height: 100px;
      display: inline-block;
      vertical-align: middle;
    }
  }
  .HomeProcess_stepLabel {
    font-size: 24px;
    font-weight: 700;
    font-family: ${typography.Serif};
    display: block;
    margin: 0 0 10px 0;
    text-transform: uppercase;
  }
  .HomeProcess_stepContent {
    font-size: 21px;
    line-height: 1.2;
    color: ${colors.black};
    font-weight: 700;
  }
`;

function HomeProcess({ page }) {
  return (
    <div className={styles}>
      <h3 className="HomeProcess_title">
        <span className="HomeProcess_preTitle">Our Process</span> Made Simple
      </h3>
      <h4 className="HomeProcess_subTitle">
        Four Easy Steps!
      </h4>
      <div className="container">
        <div className="row justify-content-between">
          {
            get(page, 'home_process').map((item, index) => (
              <div key={item.title} className="HomeProcess_stepWrapper col-lg-3">
                <div className="HomeProcess_stepImage">
                  <img src={item.image.contentUrl} alt="" />
                </div>
                <div className="HomeProcess_stepContent">
                  <span className="HomeProcess_stepLabel">Step {index + 1}</span>
                  <h4 className="Process_title">{item.title}</h4>
                </div>
              </div>
            ))
          }
        </div>
        <Link name="homebuilding-process" className="btn mx-4">Learn More</Link>
      </div>
    </div>
  );
}

HomeProcess.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'home_page',
})(HomeProcess);



// WEBPACK FOOTER //
// ./src/pages/IndexPage/HomeProcess.js